import { StatoFascicoloEnum } from "../enum/stato-fascicolo-enum";
import { SettoreDTO } from "./settoreDTO";
import { ProcedimentoDTO } from "./procedimentoDTO";
import { CampoSpecificoFascicoloDTO } from "./campo-specifico-fascicoloDTO";
import { TempiConservazioneDTO } from "./tempi-conservazioneDTO";
import { ClassificaDTO } from "./classificaDTO";
import { TipoIstanzaFascicoloDTO } from "./tipo-istanza-fascicoloDTO";
import { StatoAttoEnum } from "../enum/stato-atto-enum";
import { UtenteDTO } from "./utenteDTO";
import { TipologiaDecretoEnum } from "../enum/tipologia-decreto-enum";

export class FiltroRicercaAttoDTO {
  annoAtto: number;
  ricercaSemplice: string;
  oggetto: string;
  stato: StatoAttoEnum[];
  statoDaEscludere: StatoAttoEnum;
  dataAnniAperturaDal: string;
  dataAnniAperturaAl: string;
  dataAnniChiusuraDal: string;
  dataAnniChiusuraAl: string;
  dataInserimentoDal: string;
  sedutaPrenotata: boolean;
  dataInserimentoAl: string;
  redattore: UtenteDTO;
  responsabile: UtenteDTO;
  voceClassifica: ClassificaDTO;
  tipologiaFascicolo: TipoIstanzaFascicoloDTO;
  settore: SettoreDTO;
  segnaturaArchivistica: string;
  procedimentiAmministrativiAssociati: ProcedimentoDTO[];
  campiSpecifici: CampoSpecificoFascicoloDTO[];
  numeroRepertorio: number;
  dataRepertoriazioneDal: string;
  dataRepertoriazioneAl: string;
  tempiConservazione: TempiConservazioneDTO;
  tipologiaDecreto?: TipologiaDecretoEnum | "";
  limitazioniVisibilita: boolean;
  pageNumber: number;
  textSearch: string;
  sort: string;
  direz: string;
  //tipo (digitale/cartaceo, solo se si decide di inserirlo tra i metadati del fascicolo).
}
